import { render, staticRenderFns } from "./ProductWaitShipTables.vue?vue&type=template&id=a435dcb2&"
import script from "./ProductWaitShipTables.vue?vue&type=script&lang=js&"
export * from "./ProductWaitShipTables.vue?vue&type=script&lang=js&"
import style0 from "./ProductWaitShipTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports